import { useSearchParams } from 'react-router-dom';
import { INTEGRATION_TYPES } from '@/lib/constants';
import { NotionIntegrationPage } from '@/features/integrations/components/NotionIntegrationPage';
import { SlackIntegrationPage } from '@/features/integrations/components/SlackIntegrationPage';

export default function IntegrationsPage() {
    const [searchParams] = useSearchParams();
    const integrationType = searchParams.get('integrationType');

    if (integrationType === INTEGRATION_TYPES.NOTION) {
        return <NotionIntegrationPage />;
    }

    if (integrationType === INTEGRATION_TYPES.SLACK) {
        return <SlackIntegrationPage />;
    }

    return <div>Integrations</div>;
}
